import IAttachment, { IAttachmentResponseModel } from "./IAttachment";
import IGeoCoordinate from "./IGeoCoordinate";

export default interface ISaleComp {
    id: number;
    address: string;
    regridId: string | null;
    saleDate: Date;
    salePrice: number;
    grossPerAcre: number;
    zoning: string | null;
    buildingSize: number | null;
    parcelSizeAcres: number;
    landSizeUsable: number;
    pipedriveBuyerId: number | null;
    buyerName: string | null;
    pipedriveSellerId: number | null;
    sellerName: string | null;
    notes: string | null;
    centerPoint: IGeoCoordinate;
    propertyType: SaleCompPropertyType | null;
    dealProfile: SaleCompDealProfile | null;
    noi: number | null;
    capRate: number | null;
    isMarketed: boolean;
    pipedriveBrokerageId: number | null;
    brokerageName: string | null;
    modifiedByUser: string | null;
    modifiedDate: Date;
    buildingPerSqFt: number | null;
    pricePerUsableAcre: number | null;
    compSource: SaleCompSource | null;
    attachments: IAttachment[];
}

export interface ISaleCompResponseModel {
    id: number;
    latitude: number;
    longitude: number;
    address: string;
    regridId: string | null;
    saleDate: string;
    salePrice: number;
    parcelSizeAcres: number;
    landSizeUsable: number;
    grossPerAcre: number;
    pipedriveBuyerId: number | null;
    buyerName: string | null;
    pipedriveSellerId: number | null;
    sellerName: string | null;
    notes: string | null;
    zoning: string | null;
    buildingSize: number | null;
    propertyType: SaleCompPropertyType | null;
    dealProfile: SaleCompDealProfile | null;
    noi: number | null;
    capRate: number | null;
    marketed: boolean | null;
    pipedriveBrokerageId: number | null;
    pipedriveBrokerage: string | null;
    modifiedByUser: string | null;
    modifiedDate: string;
    pricePerUsableAcre: number | null;
    buildingPerSqFt: number | null;
    compSource: SaleCompSource | null;
    attachments: IAttachmentResponseModel[];
}

export interface ISaleCompRequestModel {
    id?: number;
    latitude: number;
    longitude: number;
    address: string;
    regridId: string | null;
    saleDate: string;
    salePrice: number;
    parcelSizeAcres: number;
    landSizeUsable: number;
    grossPerAcre: number;
    pipedriveBuyerId: number | null;
    buyerName: string | null;
    pipedriveSellerId: number | null;
    sellerName: string | null;
    notes: string | null;
    zoning: string | null;
    buildingSize: number | null;
    propertyType: SaleCompPropertyType | null;
    dealProfile: SaleCompDealProfile | null;
    noi: number | null;
    capRate: number | null;
    marketed: boolean;
    pipedriveBrokerageId: number | null;
    pipedriveBrokerage: string | null;
    pricePerUsableAcre: number | null;
    buildingPerSqFt: number | null;
    compSource: SaleCompSource | null;
}

export interface ISaleCompState {
    address: string | null;
    saleDate: Date | null;
    salePrice: number | null;
    grossPerAcre: number | null;
    zoning: string | null;
    buildingSize: number | null;
    parcelSizeAcres: number | null;
    landSizeUsable: number | null;
    buyerName: string | null;
    isBuyerIndividual: boolean;
    sellerName: string | null;
    isSellerIndividual: boolean;
    notes: string | null;
    propertyType: SaleCompPropertyType | null;
    dealProfile: SaleCompDealProfile | null;
    noi: number | null;
    capRate: number | null;
    isMarketed: boolean;
    brokerageName: string | null;
    isBrokerageIndividual: boolean;
    buildingPerSqFt: number | null;
    pricePerUsableAcre: number | null;
    compSource: SaleCompSource | null;
}

export class SaleCompState implements ISaleCompState {
    address: string | null = null;
    saleDate: Date | null = null;
    salePrice: number | null = null;
    grossPerAcre: number | null = null;
    zoning: string | null = null;
    buildingSize: number | null = null;
    parcelSizeAcres: number | null = null;
    landSizeUsable: number | null = null;
    buyerName: string | null = null;
    isBuyerIndividual: boolean = false;
    sellerName: string | null = null;
    isSellerIndividual: boolean = false;
    notes: string | null = null;
    propertyType: SaleCompPropertyType | null = null;
    dealProfile: SaleCompDealProfile | null = null;
    noi: number | null = null;
    capRate: number | null = null;
    isMarketed: boolean = false;
    brokerageName: string | null = null;
    isBrokerageIndividual: boolean = false;
    buildingPerSqFt: number | null = null;
    pricePerUsableAcre: number | null = null;
    compSource: SaleCompSource | null = null;

    static empty(): SaleCompState {
        return new SaleCompState();
    }
}

export enum SaleCompSource {
    PropertyOwner = "PropertyOwner",
    TransactionBroker = "TransactionBroker",
    PublicRecord = "PublicRecord",
    ThirdPartyBroker = "ThirdPartyBroker",
    Costar = "Costar"
}

export enum SaleCompPropertyType {
    RawLand = "RawLand",
    DataCenterLand = "DataCenterLand",
    DistributionDevelopmentLand = "DistributionDevelopmentLand",
    IOSNoBuilding = "IOSNoBuilding",
    IOSWithBuilding = "IOSWithBuilding",
    SmallBay = "SmallBay",
    Distribution = "Distribution",
    SelfStorage = "SelfStorage",
    RVBoatStorage = "RVBoatStorage",
    TruckTerminal = "TruckTerminal",
    Other = "Other"
}

export enum SaleCompDealProfile {
    UserSale = "UserSale",
    ValueAdd = "ValueAdd",
    Development = "Development",
    Core = "Core",
    CorePlus = "CorePlus"
}
